import { testIdAttr } from '@src/components/testId';
import './Frame.css';

export type FrameRatio = 'wide';

export interface FrameProps {
  src: string;
  alt?: string;
  /** wide — 16 / 9, the landing hero. */
  ratio?: FrameRatio;
  testId?: string;
}

/** Clipped media: rounded, covered, a chosen ratio. Not a layout. */
export function Frame({ src, alt = '', ratio = 'wide', testId }: FrameProps) {
  return (
    <div className={`frame frame--${ratio}`} {...testIdAttr(testId)}>
      <img className="frame__image" src={src} alt={alt} />
    </div>
  );
}
